module.exports = __webpack_public_path__ + "static/img/nanhua_logo.044fcd9d.png";